<template>
  <zt-modal
    :active="isActiveModalInfo"
    :title="$t('message.publishDocuments.modals.notification.title')"
    @close="closeDialog"
    max-width="600px"
  >
    <template>
      <div class="flex items-center px-10 py-16">
        <div class="flex flex-none items-center w-24 h-24 justify-center mr-16">
          <zt-icon
            name="exclamation-circle-outline"
            class="text-zt-warning"
            :style="{ fontSize: '6rem' }"
          />
        </div>
        <div>
          <p class="text-zt-lg">
            {{ $t('message.publishDocuments.modals.notification.question') }} <br>
            <span class="font-bold">{{ NotificationModalStore.docName }}</span>?
          </p>
          <p v-if="statePublish.prePublicationValidator" class="text-zt-lg pt-4">
            {{ $t('message.publishDocuments.modals.notification.onlyUnreceivedCollaborators') }} <br>
          </p>
        </div>
      </div>
    </template>

    <template #modal-footer>
      <div
        class="zt-modal-footer rounded-b flex justify-center lg:justify-end items-center p-4"
      >
        <zt-button
          outlined
          data-vs-button="no-notifications"
          class="mr-1 text-primary-200"
          @click="closeDialog"
        >
          {{ $t('message.publishDocuments.modals.notification.cancel') }}
        </zt-button>
        <zt-button
          data-vs-button="with-notifications"
          :loader="loadingButton"
          @click="publish"
        >
          {{ $t('message.publishDocuments.modals.notification.send') }}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>

<script>
export default {
  name: 'ModalNotificationUser',
  inject: [
    'publishDocument',
    'setActiveNotificationModal',
    'NotificationModalStore',
    'statePublish'
  ],
  props: {
    isActiveModalInfo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingButton: false,
      isSending: false
    }
  },
  methods: {
    closeDialog() {
      if (this.isSending) return
      this.setActiveNotificationModal(false)
    },
    async publish() {
      this.loadingButton = true
      this.isSending = true
      await this.publishDocument()
      this.isSending = false
      this.closeDialog()
      this.loadingButton = false
    }
  }
}
</script>

<style scoped>
.warning-icon {
  width: 70px;
  height: 70px;

  border-radius: 50%;
  border: 2px solid #fb8c00;
  color: #fb8c00;
}
.warning-icon i {
  font-size: 2.438rem;
}
.zt-modal-footer {
  background-color: #eee;
}
::v-deep .zt-button.text-primary-200 {
  color: #4f41a3 !important;
  background-color: #eee;
}
::v-deep .zt-modal.rounded {
  border-radius: 0.375rem !important;
}
</style>